import { Messages } from '../../../codegen/Localize';
import { Order } from '../../../ts/helpers/Order';
import { OrderKeys } from '../../../ts/models/OrderKeys';
import { SortOptions } from '../../../ts/models/sort/CommonSortOptions';
import { OptionsDictionary } from '../../../ts/models/sort/SortOptionDefinitions';

export const extractRefreshSortOptions: OptionsDictionary = {
  'targetType': {
    id: OrderKeys.targetType,
    field: OrderKeys.targetType,
    getMenuItemDisplayValue: Messages.column_content_type,
    getButtonDisplayValue: Messages.column_content_type,
    ascending: true,
    toOrderClauseArray: () => [{
      field: OrderKeys.targetType,
      ascending: true
    }, { field: OrderKeys.targetName, ascending: true }]
  },
  'targetName': {
    id: OrderKeys.targetName,
    getMenuItemDisplayValue: Messages.column_workbook_or_datasource,
    subSortOptions: {
      'asc': {
        id: 'targetName.asc',
        field: OrderKeys.targetName,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.targetName)]
      },
      'desc': {
        id: 'targetName.desc',
        field: OrderKeys.targetName,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.targetName)]
      }
    }
  },
  'tasktype': {
    id: OrderKeys.type,
    getMenuItemDisplayValue: Messages.column_task_type,
    subSortOptions: {
      'asc': {
        id: 'type.asc',
        field: OrderKeys.type,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.type)]
      },
      'desc': {
        id: 'type.desc',
        field: OrderKeys.type,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.type)]
      }
    }
  },
  'schedule': SortOptions.schedule,
  'priority': {
    id: OrderKeys.priority,
    getMenuItemDisplayValue: Messages.column_task_priority,
    subSortOptions: {
      'asc': {
        id: 'priority.asc',
        field: OrderKeys.priority,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.priority)]
      },
      'desc': {
        id: 'priority.desc',
        field: OrderKeys.priority,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.priority)]
      }
    }
  },
  'lastRunAt': SortOptions.lastRunAt,
  'runNextAt': SortOptions.runNextAt,
  'siteName': SortOptions.siteName
};
